"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var model_1 = require("../shared/model");
var shared_1 = require("@formily/shared");
var normalizeMessages = function (messages) { return shared_1.toArr(messages).filter(function (v) { return !!v; }); };
var calculateEditable = function (selfEditable, formEditable, name) {
    return shared_1.isValid(selfEditable)
        ? selfEditable
        : shared_1.isValid(formEditable)
            ? shared_1.isFn(formEditable)
                ? formEditable(name)
                : formEditable
            : true;
};
exports.ARRAY_UNIQUE_TAG = Symbol.for('@@__YOU_CAN_NEVER_REMOVE_ARRAY_UNIQUE_TAG__@@');
exports.parseArrayTags = function (value) {
    var _a;
    if (!shared_1.isArr(value))
        return [];
    return (_a = value === null || value === void 0 ? void 0 : value.reduce) === null || _a === void 0 ? void 0 : _a.call(value, function (buf, item) {
        return (item === null || item === void 0 ? void 0 : item[exports.ARRAY_UNIQUE_TAG]) ? buf.concat(item[exports.ARRAY_UNIQUE_TAG]) : buf;
    }, []);
};
exports.tagArrayList = function (current, name, force) {
    var _a;
    return (_a = current === null || current === void 0 ? void 0 : current.map) === null || _a === void 0 ? void 0 : _a.call(current, function (item, index) {
        if (shared_1.isPlainObj(item)) {
            item[exports.ARRAY_UNIQUE_TAG] = force
                ? name + "." + index
                : item[exports.ARRAY_UNIQUE_TAG] || name + "." + index;
        }
        return item;
    });
};
exports.Field = model_1.createModel((_a = (function () {
        function FieldStateFactory(props) {
            var _this = this;
            if (props === void 0) { props = {}; }
            this.state = {
                name: '',
                path: '',
                dataType: 'any',
                initialized: false,
                pristine: true,
                valid: true,
                modified: false,
                inputed: false,
                touched: false,
                active: false,
                visited: false,
                invalid: false,
                visible: true,
                display: true,
                loading: false,
                validating: false,
                errors: [],
                values: [],
                ruleErrors: [],
                ruleWarnings: [],
                effectErrors: [],
                warnings: [],
                effectWarnings: [],
                editable: true,
                selfEditable: undefined,
                formEditable: undefined,
                value: undefined,
                visibleCacheValue: undefined,
                initialValue: undefined,
                rules: [],
                required: false,
                mounted: false,
                unmounted: false,
                props: {}
            };
            this.getState = function () {
                var _a, _b;
                if (!_this.state.initialized)
                    return _this.state;
                var value = _this.getValueFromProps();
                var initialValue = _this.getInitialValueFromProps();
                var formEditable = _this.getEditableFromProps();
                if (_this.isArrayList()) {
                    value = _this.fixArrayListTags(shared_1.toArr(value));
                    initialValue = _this.fixArrayListTags(shared_1.toArr(initialValue));
                }
                var valueChanged = !shared_1.isEqual(_this.state.value, value);
                var state = __assign(__assign({}, _this.state), { initialValue: initialValue,
                    formEditable: formEditable, editable: calculateEditable(_this.state.selfEditable, formEditable, _this.state.name), modified: _this.state.modified || valueChanged, value: value, values: [value].concat(_this.state.values.slice(1)) });
                if (valueChanged && valueChanged !== _this.lastCompareResults) {
                    _this.state.value = value;
                    (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.unControlledValueChanged) === null || _b === void 0 ? void 0 : _b.call(_a);
                }
                _this.lastCompareResults = valueChanged;
                return state;
            };
            this.nodePath = shared_1.FormPath.getPath(props.nodePath);
            this.dataPath = shared_1.FormPath.getPath(props.dataPath);
            this.state.name = this.dataPath.entire;
            this.state.path = this.nodePath.entire;
            this.state.dataType = props.dataType;
            this.props = props;
            this.updates = [];
        }
        FieldStateFactory.prototype.dirtyCheck = function (path, currentValue, nextValue) {
            if (path[0] === 'value') {
                if (this.isArrayList()) {
                    return true;
                }
            }
            return !shared_1.isEqual(currentValue, nextValue);
        };
        FieldStateFactory.prototype.getValueFromProps = function () {
            var _a;
            if (shared_1.isFn((_a = this.props) === null || _a === void 0 ? void 0 : _a.getValue)) {
                return this.props.getValue(this.state.name);
            }
            return this.state.value;
        };
        FieldStateFactory.prototype.getEditableFromProps = function () {
            var _a, _b;
            return (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.getEditable) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        FieldStateFactory.prototype.getInitialValueFromProps = function () {
            var _a;
            if (shared_1.isFn((_a = this.props) === null || _a === void 0 ? void 0 : _a.getInitialValue)) {
                var initialValue = this.props.getInitialValue(this.state.name);
                return shared_1.isValid(this.state.initialValue)
                    ? this.state.initialValue
                    : initialValue;
            }
            return this.state.initialValue;
        };
        FieldStateFactory.prototype.produceErrorsAndWarnings = function (draft, dirtys) {
            if (dirtys.errors) {
                draft.effectErrors = normalizeMessages(draft.errors);
            }
            if (dirtys.warnings) {
                draft.effectWarnings = normalizeMessages(draft.warnings);
            }
            if (dirtys.effectErrors) {
                draft.effectErrors = normalizeMessages(draft.effectErrors);
            }
            if (dirtys.effectWarnings) {
                draft.effectWarnings = normalizeMessages(draft.effectWarnings);
            }
            if (dirtys.ruleErrors) {
                draft.ruleErrors = normalizeMessages(draft.ruleErrors);
            }
            if (dirtys.ruleWarnings) {
                draft.ruleWarnings = normalizeMessages(draft.ruleWarnings);
            }
            draft.errors = draft.ruleErrors.concat(draft.effectErrors);
            draft.warnings = draft.ruleWarnings.concat(draft.effectWarnings);
        };
        FieldStateFactory.prototype.produceEditable = function (draft, dirtys) {
            if (dirtys.editable) {
                draft.selfEditable = draft.editable;
            }
            draft.editable = calculateEditable(draft.selfEditable, draft.formEditable, draft.name);
        };
        FieldStateFactory.prototype.supportUnmountClearStates = function () {
            var _a, _b;
            if (shared_1.isFn((_a = this.props) === null || _a === void 0 ? void 0 : _a.supportUnmountClearStates)) {
                return (_b = this.props) === null || _b === void 0 ? void 0 : _b.supportUnmountClearStates(this.state.path);
            }
            return true;
        };
        FieldStateFactory.prototype.produceSideEffects = function (draft, dirtys) {
            var supportClearStates = this.supportUnmountClearStates();
            if (dirtys.validating) {
                if (draft.validating === true) {
                    draft.loading = true;
                }
                else if (draft.validating === false) {
                    draft.loading = false;
                }
            }
            if (draft.editable === false ||
                draft.selfEditable === false ||
                draft.visible === false ||
                draft.display === false ||
                (draft.unmounted === true && supportClearStates)) {
                draft.errors = [];
                draft.effectErrors = [];
                draft.warnings = [];
                draft.effectWarnings = [];
            }
            if (!shared_1.isValid(draft.props)) {
                draft.props = {};
            }
            if (draft.mounted === true && dirtys.mounted) {
                draft.unmounted = false;
            }
            if (draft.mounted === false && dirtys.mounted) {
                draft.unmounted = true;
            }
            if (draft.unmounted === true && dirtys.unmounted) {
                draft.mounted = false;
            }
            if (draft.unmounted === false && dirtys.unmounted) {
                draft.mounted = true;
            }
            if (dirtys.visible || dirtys.mounted || dirtys.unmounted) {
                if (supportClearStates) {
                    if (draft.display) {
                        if (draft.visible === false || draft.unmounted === true) {
                            if (!dirtys.visibleCacheValue) {
                                draft.visibleCacheValue = shared_1.isValid(draft.value)
                                    ? draft.value
                                    : shared_1.isValid(draft.visibleCacheValue)
                                        ? draft.visibleCacheValue
                                        : draft.initialValue;
                            }
                            draft.value = undefined;
                            draft.values = shared_1.toArr(draft.values);
                            draft.values[0] = undefined;
                            this.updates.push('value');
                        }
                        else if (draft.visible === true ||
                            draft.mounted === true ||
                            draft.unmounted === false) {
                            if (!shared_1.isValid(draft.value)) {
                                draft.value = draft.visibleCacheValue;
                                this.updates.push('value');
                            }
                        }
                    }
                }
                else {
                    if (draft.display) {
                        if (draft.visible === false) {
                            if (!dirtys.visibleCacheValue) {
                                draft.visibleCacheValue = shared_1.isValid(draft.value)
                                    ? draft.value
                                    : shared_1.isValid(draft.visibleCacheValue)
                                        ? draft.visibleCacheValue
                                        : draft.initialValue;
                            }
                            draft.value = undefined;
                            draft.values = shared_1.toArr(draft.values);
                            draft.values[0] = undefined;
                        }
                        else if (draft.visible === true) {
                            if (!shared_1.isValid(draft.value)) {
                                draft.value = draft.visibleCacheValue;
                            }
                        }
                    }
                }
            }
            if (draft.errors.length) {
                draft.invalid = true;
                draft.valid = false;
            }
            else {
                draft.invalid = false;
                draft.valid = true;
            }
        };
        FieldStateFactory.prototype.fixArrayListTags = function (value) {
            var _a;
            if ((_a = value === null || value === void 0 ? void 0 : value[0]) === null || _a === void 0 ? void 0 : _a[exports.ARRAY_UNIQUE_TAG]) {
                return value;
            }
            else {
                return this.tagArrayList(value);
            }
        };
        FieldStateFactory.prototype.tagArrayList = function (value) {
            return exports.tagArrayList(value, this.state.name);
        };
        FieldStateFactory.prototype.isArrayList = function () {
            return /array/gi.test(this.state.dataType);
        };
        FieldStateFactory.prototype.produceValue = function (draft, dirtys) {
            var valueOrInitialValueChanged = dirtys.values || dirtys.value || dirtys.initialValue;
            var valueChanged = dirtys.values || dirtys.value;
            if (dirtys.values) {
                draft.values = shared_1.toArr(draft.values);
                if (this.isArrayList()) {
                    draft.values[0] = this.tagArrayList(shared_1.toArr(draft.values[0]));
                }
                draft.value = draft.values[0];
                draft.modified = true;
            }
            if (dirtys.value) {
                if (this.isArrayList()) {
                    draft.value = this.tagArrayList(shared_1.toArr(draft.value));
                }
                draft.values[0] = draft.value;
                draft.modified = true;
            }
            if (dirtys.initialized) {
                var isEmptyValue = !shared_1.isValid(draft.value) || shared_1.isEmpty(draft.value);
                if (isEmptyValue && shared_1.isValid(draft.initialValue)) {
                    draft.value = draft.initialValue;
                    draft.values = shared_1.toArr(draft.values);
                    draft.values[0] = draft.value;
                    valueChanged = true;
                    valueOrInitialValueChanged = true;
                }
            }
            if (valueChanged) {
                this.updates.push('value');
            }
            if (dirtys.initialValue) {
                this.updates.push('initialValue');
            }
            if (valueOrInitialValueChanged) {
                if (shared_1.isEqual(draft.initialValue, draft.value)) {
                    draft.pristine = true;
                }
                else {
                    draft.pristine = false;
                }
            }
        };
        FieldStateFactory.prototype.getRulesFromRulesAndRequired = function (rules, required) {
            if (shared_1.isValid(required)) {
                if (rules.length) {
                    if (!rules.some(function (rule) { return rule && shared_1.isValid(rule['required']); })) {
                        return rules.concat([{ required: required }]);
                    }
                    else {
                        return rules.reduce(function (buf, item) {
                            var keys = Object.keys(item || {});
                            if (shared_1.isValid(item.required)) {
                                if (shared_1.isValid(item.message)) {
                                    if (keys.length > 2) {
                                        return buf.concat(__assign(__assign({}, item), { required: required }));
                                    }
                                }
                                else {
                                    if (keys.length > 1) {
                                        return buf.concat(__assign(__assign({}, item), { required: required }));
                                    }
                                }
                            }
                            if (shared_1.isValid(item.required)) {
                                return buf.concat(__assign(__assign({}, item), { required: required }));
                            }
                            return buf.concat(item);
                        }, []);
                    }
                }
                else {
                    if (required === true) {
                        return rules.concat([
                            {
                                required: required
                            }
                        ]);
                    }
                }
            }
            return rules;
        };
        FieldStateFactory.prototype.getRequiredFromRulesAndRequired = function (rules, required) {
            for (var i = 0; i < rules.length; i++) {
                if (shared_1.isValid(rules[i].required)) {
                    return rules[i].required;
                }
            }
            return required;
        };
        FieldStateFactory.prototype.produceRules = function (draft, dirtys) {
            if (shared_1.isValid(draft.rules)) {
                draft.rules = shared_1.toArr(draft.rules);
            }
            if ((dirtys.required && dirtys.rules) || dirtys.required) {
                var rules = this.getRulesFromRulesAndRequired(draft.rules, draft.required);
                draft.required = draft.required;
                draft.rules = rules;
            }
            else if (dirtys.rules) {
                draft.required = this.getRequiredFromRulesAndRequired(draft.rules, draft.required);
            }
        };
        FieldStateFactory.prototype.beforeProduce = function () {
            this.updates = [];
        };
        FieldStateFactory.prototype.produce = function (draft, dirtys) {
            this.produceErrorsAndWarnings(draft, dirtys);
            this.produceEditable(draft, dirtys);
            this.produceValue(draft, dirtys);
            this.produceSideEffects(draft, dirtys);
            this.produceRules(draft, dirtys);
        };
        FieldStateFactory.prototype.afterProduce = function () {
            var _this = this;
            this.updates.forEach(function (type) {
                var _a, _b, _c, _d;
                if (type === 'value') {
                    (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.setValue) === null || _b === void 0 ? void 0 : _b.call(_a, _this.state.name, _this.state.value);
                }
                else {
                    (_d = (_c = _this.props) === null || _c === void 0 ? void 0 : _c.setInitialValue) === null || _d === void 0 ? void 0 : _d.call(_c, _this.state.name, _this.state.initialValue);
                }
            });
        };
        return FieldStateFactory;
    }()),
    _a.defaultProps = {
        path: '',
        dataType: 'any'
    },
    _a.displayName = 'FieldState',
    _a));



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/core/lib/models/field.js
// module id = 5759
// module chunks = 0